import { Page, PageVariant, StatusWidget } from '@revolut-internal/ui-kit'
import { Link } from 'react-router-dom'

import { getRootRoute } from 'lib/router'

export const ErrorFallback = () => (
  <Page variant={PageVariant.FOCUSED}>
    <Page.Main>
      <StatusWidget>
        <StatusWidget.Image
          image={{
            default: 'https://assets.revolut.com/assets/3d-images-v2/3D018.png',
            '2x': 'https://assets.revolut.com/assets/3d-images-v2/3D018@2x.png',
            '3x': 'https://assets.revolut.com/assets/3d-images-v2/3D018@3x.png',
          }}
        />
        <StatusWidget.Title>Something went wrong</StatusWidget.Title>
        <StatusWidget.Action>
          <Link to={getRootRoute()}>Home page</Link>
        </StatusWidget.Action>
      </StatusWidget>
    </Page.Main>
  </Page>
)
